<template>
    <main-content with_go_back_bar>
        <kt-panel>
            <div class="create-services">
                <div class="mx-3">
                    <button @click.prevent="showModal" class="btn btn-success">
                        افزودن فیلد دلخواه
                    </button>
                </div>
                <router-link to="/customer-formats" class="mr-2">
                    <button class="btn btn-success">بازگشت</button>
                </router-link>
            </div>
            <CreateFieldModal @addField="addField" />
            <form
                @submit.prevent="submit($event, query)"
                id="single-request-form"
                class="kt-form p-3 my-4"
                v-if="
                    detailCustomerFormatStatus === 'success' &&
                    detailCustomerFormat.fields.length > 0
                "
            >
                <div
                    class="p-3 border in-border-header"
                    style="padding-top: 1.5rem !important"
                >
                    <kt-form-section is_first>
                        <div class="section-header">
                            {{ $t('online-factor.label_format') }}
                        </div>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="legal_business_name">
                                    {{ $t('online-factor.name') }}
                                    <span class="text-danger h5 pb-3">*</span>
                                </kt-form-label>
                                <kt-form-control
                                    id="legal_business_name"
                                    name="legal_business_name"
                                    v-model="detailCustomerFormat.name"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <div class="d-flex flex-wrap justify-content-between">
                            <CustomerFormatField
                                class="my-3 col-lg-6 col-md-6 col-12"
                                v-for="field in detailCustomerFormat.fields"
                                :key="field.id"
                                :field="field"
                                :query="query"
                                @remove-field="removeField"
                                @field-status-changed="handleFieldStatusChanged"
                            />
                        </div>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-button
                                id="form-btn"
                                class="btn my-4 mt-2 btn-success btn-wide text-center py-2"
                                type="submit"
                                variant="success"
                            >
                                به روزرسانی
                            </kt-button>
                        </kt-col>
                    </kt-form-section>
                </div>
            </form>
        </kt-panel>
    </main-content>
</template>

<script>
import $ from 'jquery';
import toastr from 'toastr';
import { KTApp } from '@/plugins/core/app';
import { mapGetters } from 'vuex';
import mainContent from '@/components/main-content';
import { onlineFactorService } from '@/common/shop.service';
import CustomerFormatField from '@/views/online-factor/components/CustomerFormatField.vue';
import { fieldOptions } from '@/constants/CustomerFormatFieldsOptions';
import CreateFieldModal from './components/CreateFieldModal.vue';

export default {
    components: {
      CreateFieldModal,
        CustomerFormatField,
        'main-content': mainContent
    },
    data() {
        return {
            query: {},
            hashid: this.$route.params.hashid,
            fields: []
        };
    },
    computed: {
        ...mapGetters('moneyRequest', [
            'detailCustomerFormat',
            'detailCustomerFormatStatus'
        ]),
        fieldOptions(){
          return fieldOptions
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: 'toast-bottom-center',
                preventDuplicates: false,
                rtl: false
            };
            return toastr;
        }
    },
    mounted() {
        this.$store.dispatch(
            'moneyRequest/showCustomerFormat',
            this.$route.params.hashid
        );
    },
    methods: {
        addField(custom_field) {
          if (
              this.detailCustomerFormat.fields.some(item => item.name === custom_field.name)
              || this.detailCustomerFormat.fields.some(item => item.fa_name === custom_field.fa_name)
          ) {
            $('#add_custom_field').modal('hide')
            return this.toastr.error('فیلد با این نام و یا نام انگلیسی در قالب شما وجود دارد!')
          }

          custom_field.id = this.fields.length + 1
          this.detailCustomerFormat.fields.push(custom_field)
          $('#add_custom_field').modal('hide')
        },
        showModal() {
          $('#add_custom_field').modal('show')
        },
        removeField(field_id) {
          if (window.confirm('آیا می خواهید این فیلد به طور کلی حذف شود؟')) {
            onlineFactorService.deleteField(field_id)
                .then(response => {
                  this.toastr.success(response.data.message)
                  this.detailCustomerFormat.fields = this.detailCustomerFormat.fields.filter(item => item.id !== field_id)
                })
                .catch(({ response }) => {
                  this.toastr.error(response.data.message)
                })
          } else {
            this.detailCustomerFormat.fields = this.detailCustomerFormat.fields.filter(item => item.id !== field_id)
          }
        },
        handleFieldStatusChanged(field) {
          this.detailCustomerFormat.fields.find(item => item.id === field.id).status = field.status
        },
        submit(e) {
            let btn = $('#form-btn');
            const data = {
                'name': this.detailCustomerFormat.name,
                'fields': this.detailCustomerFormat.fields
            }

            KTApp.progress(btn);
            // update Customer
            onlineFactorService
                .updateCustomerFormat(this.hashid, data)
                .then(response => {
                    if (response.status === 200) {
                        this.$router.push('/customer-formats');
                    }
                })
                .catch(({response}) => {
                    this.toastr.error(response.data.message);
                    for (let err in response.data.data) {
                        this.toastr.error(response.data.data[err][0]);
                    }
                })
                .finally(() => {
                    KTApp.unprogress(btn);
                });
        }
    }
};
</script>
<style scoped>
.preview_img {
    max-width: 70px;
    max-height: 70px;
    position: absolute;
    top: 10px;
    left: 80px;
}

.optionCityDetails {
    margin: -2rem 1rem 0 0;
}

.create-services {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-end;
}
</style>